import { Component, ElementRef, NgZone, Renderer2 } from '@angular/core';
import { ViewportScroller } from "@angular/common";
import { SchemaService } from '../../services/schema.service';
import { FormControl, FormGroup } from '@angular/forms';
import { LanguageService } from '../../services/language.service';
import { KeyValueObject } from '../../interfaces/common.interface';
import { DevelopmentService } from '../../services/development.service';
import { Router } from '@angular/router';
import { TextToSpeechService } from '../../services/text-to-speech.service';
import { ConsentToAccessService } from '../../../module/consent-to-access/consent-to-access.service';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrl: './header-top.component.scss'
})
export class HeaderTopComponent {
  // Social Icon
  selectedLanguage: string = 'English';

  socialicon = [{ icon: "Facebook.png", name: 'Facebook' }, { icon: "Instagram.png", name: 'Instagram' }, { icon: "Twitter.png", name: 'Twitter' }];
  clientlogo = 'assets/images/logo/Logo.png';
  // Language
  listItems = [{ value: 'mr', name: "मराठी" }, { value: 'en', name: "English" }];
  langData: KeyValueObject[];
  currentLanguage: string = 'मराठी'
  switchTo: string = 'Switch to Dark view';
  iconClass: string = '';
  constructor(
    private scroller: ViewportScroller,
    private schemaService: SchemaService,
    public langService: LanguageService,
    private renderer: Renderer2,
    private el: ElementRef,
    private DS: DevelopmentService,
    private router: Router,
    protected textToSpeechService: TextToSpeechService,
    private ngZone: NgZone,
   public consentAccessService: ConsentToAccessService,
  ) { }

  themes = ['red',   'green',  'blue', 'pink', 'black'];
  currentTheme: string = 'red';

  async ngOnInit(): Promise<void> {
    document.addEventListener('keydown', this.handleKeyboardEvent);
    //         const existing = document.querySelector('script[src*="bhashini"]');
    // if (!existing) {
    //   const script = this.renderer.createElement('script');
    //   script.src = '';
    //   script.async = true;
    //   //script.setAttribute('language-code', 'mr');
    //   script.setAttribute('language-icon-color', '#ffffff');
    //   this.renderer.appendChild(document.body, script);
    // }
    //    const script = this.renderer.createElement('script');
    // script.src = '';
    // script.async = true;
    // script.setAttribute('language-icon-color', '#ffffff');
    // script.setAttribute('language-code', 'mr');
    // this.renderer.appendChild(document.body, script);

    await this.langService.language$.subscribe((language) => {
      switch (language) {
        case 'en':
          this.currentLanguage = 'English';
          break;
        case 'mr':
          this.currentLanguage = 'Marathi';
          break;
        default:
          this.currentLanguage = 'Marathi';
      }
      this.DS.initializeTooltips();
    })
    //    this.langService.currentLanguage$.subscribe(lang => {
    //   this.currentLanguage = lang;
    // })
    // this.langService.loadScript().catch(err => console.error(err));
     this.iconClass = this.getCurrentThemeIcon();

      this.currentTheme = this.schemaService.getCurrentTheme();
  this.schemaService.changeTheme(this.currentTheme);
    //this.loadBhashiniScript();


    
  }
  // app.component.ts (additional method)
loadBhashiniScript() {
  return new Promise<void>((resolve) => {
    if (document.querySelector('script[src*="bhashini"]')) return resolve();

    const script = document.createElement('script');
    script.src = '';
    script.onload = () => resolve();
    document.body.appendChild(script);
  });
}
  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyboardEvent);
  }
  async scrollTopPositionSkip() {
    const routerOutlets = await Array.from(document.querySelectorAll('router-outlet'));
    if (routerOutlets) {
      const e = routerOutlets[routerOutlets.length - 1].nextElementSibling.firstElementChild;
      const y = e.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y,
        behavior: 'smooth'
      });
    }
  }
  defaultValue: number = this.schemaService.getZoomFromLocalStorage();
  // Function to handle the '-' button click
  decreaseValue(event: Event) {
    if (this.defaultValue > -2) {
      this.defaultValue--;
      this.schemaService.changeZoom(this.defaultValue)
      this.DS.initializeTooltips();
    }
    setTimeout(() => {
      event.target && (event.target as HTMLButtonElement).blur();
    }, 500);
  }
  getZoom(): string {
    return this.schemaService.getZoom();
  }
  // Function to handle the '+' button click
  increaseValue(event: Event) {
    if (this.defaultValue < 2) {
      this.defaultValue++;
      this.schemaService.changeZoom(this.defaultValue)
      this.DS.initializeTooltips();
    }
    setTimeout(() => {
      event.target && (event.target as HTMLButtonElement).blur();
    }, 500);
  }

  // Function to handle the 'A' button click
  resetValue(event: Event) {
    this.defaultValue = 0;
    this.schemaService.changeZoom(this.defaultValue);
    this.DS.initializeTooltips();
    setTimeout(() => {
      event.target && (event.target as HTMLButtonElement).blur();
    }, 500);
  }
  async toggleTheme(): Promise<void> {
    const currentTheme = this.schemaService.getCurrentTheme();
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    this.schemaService.changeTheme(newTheme);
    this.switchTo = 'Switch to ' + currentTheme + ' view';
    this.resizeWindow();
    this.iconClass = this.getCurrentThemeIcon();
    await this.DS.initializeTooltips();
  }
  theme() {
    return this.schemaService.getCurrentTheme()
  }
  resizeWindow() {
    const event = new Event('resize');
    window.dispatchEvent(event);
  }
  // getCurrentThemeIcon(): string {
  //   const t = this.schemaService.getCurrentTheme();
  //   this.switchTo = 'Switch to ' + ((t == 'light') ? 'Dark' : 'Light') + ' view';
  //   return t === 'dark' ? 'fa fa-x-sun' : 'fa fa-x-moon';
  // }

  getCurrentThemeIcon(): string {
    const t = this.schemaService.getCurrentTheme();

    switch (t) {
      case 'dark': return 'fa fa-x-soon';
      case 'pink': return 'fa fa-heart';
      case 'red': return 'fa fa-fire';
      case 'blue': return 'fa fa-water';
      case 'green': return 'fa fa-leaf';
      default: return 'fa fa-circle';
    }
  }

  async setTheme(theme: string): Promise<void> {
    // this.schemaService.changeTheme(theme);

    // this.switchTo = 'Current theme: ' + theme;
    // // this.resizeWindow();
    // // this.iconClass = this.getCurrentThemeIcon();

    // // await this.DS.initializeTooltips();

    // this.currentTheme = theme;  
    // this.schemaService.changeTheme(theme);

    // this.iconClass = this.getCurrentThemeIcon();
    // this.resizeWindow();
    // await this.DS.initializeTooltips();

      if (this.currentTheme === theme) return; 

      this.currentTheme = theme;
      this.schemaService.changeTheme(theme);

      this.iconClass = this.getCurrentThemeIcon();
      this.resizeWindow();
      await this.DS.initializeTooltips();


  }

changeTheme(theme: string) {
  const body = document.body;

  // Remove old theme classes
  body.classList.remove(
    'theme-pink',
    'theme-red',
    'theme-blue',
    'theme-green',
    'theme-black'
  );

  // Add new theme class
  body.classList.add('theme-' + theme);

  sessionStorage.setItem('theme', theme);
}

getCurrentTheme(): string {
  return sessionStorage.getItem('theme') || 'red';
}
    
  ngAfterViewInit(): void {
    // this.ngZone.runOutsideAngular(() => {
    //   setTimeout(() => {
    //      const script = this.renderer.createElement('script');
    // script.src = '';
    // script.async = true;
    // script.setAttribute('language-icon-color', '#ffffff');
    // script.setAttribute('language-code', 'mr');
    // this.renderer.appendChild(document.body, script);
    //   }, 3000);
    // });
  }
  handleKeyboardEvent = (event: KeyboardEvent) => {
    if (event.shiftKey && event.key === 'v') {
      this.textToSpeechService.toggleSpeech()
      event.preventDefault(); // stop browser default

    }
  };

  scrollToSection(sectionId: string) {
    this.langService.scrollTo(sectionId);
  }

  
}
